<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="applyDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="500px"
            center>
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">上传公账支付账单凭证</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <div class="dialog-content flex flex-direction align-center">
                <el-upload
                        class="avatar-uploader"
                        :action="fileUpUrl"
                        :data="QiniuData"
                        :show-file-list="false"
                        :accept="'image/*'"
                        :on-error="uploadError"
                        :on-success="uploadSuccess"
                        :before-upload="beforeAvatarUpload">
                    <el-image class="up-image" v-if="file_path" :src="file_path"></el-image>
                    <div v-else class="up-image-up"></div>
                </el-upload>
                <div class="margin">注：提交后，我们会在24小时内进行审核</div>
            </div>
            <div class="dialog-operate flex align-center justify-center">
                <el-button class="operate black" @click="cancel">取消</el-button>
                <el-button class="operate" :loading="loading" @click="submitForm()">
                    提交
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {fileUpUrl, filePath} from '@/config/index'
    import {genUpToken} from '@/utils/CryptoJS'

    export default {
        name: "PaymentTransferDialog",
        props: {
            applyDialogVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: false,
                QiniuData: {
                    fname: '', //  文件名
                    key: '', //文件名字处理
                    token: genUpToken() //七牛云token
                },
                fileUpUrl: fileUpUrl,
                file_path: '',
            }
        },
        created() {
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
        },
        methods: {
            submitForm() {
                if (!this.file_path) return this.$message.error('请上传公账支付账单凭证')
                this.$emit('fileSuccess', {
                    file_path: this.file_path
                })
            },
            cancel() {
                this.$emit('cancelDialog', false)
            },
            beforeAvatarUpload(file) {
                this.QiniuData.fname = file.name;
                this.QiniuData.key = `${new Date().getTime()}${file.name}`
                this.uping = this.$loading({
                    lock: true,
                    text: "上传中，请稍后",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.2)",
                });
            },
            uploadSuccess(response) {
                this.uping.close();
                this.file_path = `${filePath}/${response.key}`
            },
            //  上传失败
            uploadError() {
                this.uping.close();
                this.$message({
                    message: "上传出错，请重试！",
                    type: "error",
                    center: true,
                });
            },
        },
        watch: {}
    }
</script>

<style scoped lang="scss">

    .detail-dialog-container {
        .dialog-container {
            .dialog-header {
                height: 55px;
                .dialog-title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #0a2240;
                    text-align: center;
                }
                .dialog-close {
                    font-size: 21px;
                    color: #0a2240;
                    font-weight: bold;
                    cursor: pointer;
                }
            }
            .dialog-content {
                .up-image {
                    width: 197px;
                    height: 197px;
                }
                .up-image-up {
                    width: 197px;
                    height: 197px;
                    position: relative;
                    border: 1px solid #eeeeee;
                    &:before{
                        position: absolute;
                        content: '+';
                        font-size: 26px;
                        color: #333333;
                        top:50%;
                        left: 50%;
                        transform: translate(-50%,-50%);
                    }
                }
            }
            .dialog-operate {
                margin-top: 20px;
                .operate {
                    width: 200px;
                    height: 40px;
                    border-radius: 20px;
                    font-size: 16px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#ff9600, #ff9600);
                    background-blend-mode: normal, normal;
                    color: #ffffff;
                    &.black {
                        background: #0a2240 none;
                    }
                }
                .operate + .operate {
                    margin-left: 80px;
                }
            }
            .dialog-footer {
                height: 40px;
                background-color: #e7eff9;
                padding: 0 20px;
                border-radius: 0 0 10px 10px;
                .content {
                    font-size: 16px;
                    color: #8b9fbe;
                }
            }
        }
    }
</style>